<template>
    <div class="report-page">
        <div class="home-title-bar report-page-title-bar dsp-flex">
            <div class="home-title-side home-title-side-left" @click="clickBack"><i class="iconfont icon-xiangzuo"></i></div>
            <div class="home-title-mid"><span class="home-title-title">生日五行强弱测测</span></div>
            <div class="home-title-side"><span class="home-title-button" @click="clickReport">我的报告</span></div>
        </div>
        <div class="report-info-box">
            <report-info></report-info>
        </div>

        <!-- 3、主要内容 -->
        <report-result :resultType="'strong'"></report-result>

        <div class="report-bottom-button strong-report-bottom-button">
            <!-- <button class="report-rbul-button report-rbul-button-3" @click="clickNature">
                <span class="report-rbul-button-span">查看个人天赋矩阵</span>
            </button> -->

            <!-- 二维码部分 -->
            <div class="report-bottom-info">
                <img class="report-bottom-info-qrcode" v-bind:src="logoIcon" alt="">
                <!-- <p>长按识别关注公众号</p> -->
                <!-- <p>反馈意见、合作或获取更多免费测评报告</p> -->
            </div>
        </div>

        <!-- 4、底部背景 -->
        <div class="report-bottom-bg"></div>
    </div>
</template>

<script>
import ReportInfo from '../../layouts/strong/ReportInfo.vue';
import ReportResult from '../../layouts/report/ReportResult.vue'
import * as doctitle from '../../modules/data/base/doctitle'
import { DOM } from '../../modules/dom';
export default {
    name: 'ReportPage',
    components: { ReportInfo, ReportResult },
    computed: {
        reportData() {
            return this.$store.state.report.reportData;
        },
        reportAIData() {
            return this.$store.state.report.reportAIData;
        },
        showSharePicPop() {
            return this.$store.state.share.showSharePicPop;
        }
    },
    data() {
        return {
            logoIcon: require('../../assets/images/strong/icons/icon-logo.png'),
            noteMsgList: ['',
                '注意：身强，代表具备扛住大财富的优势。是否能真正拥有大财富，还需待运而动。比如某香港巨富即是身强+财运，如果财运不来，同样是枉废天资，实属遗憾。',
                '注意：身弱，不代表不能发财致富。比如现在很多成功企业家实际都是身弱的，比如某宝老板。走到人生黄金运程有时空能量及团队能量的加持也能富甲一方，甚至冲出亚洲。'
            ]
        }
    },
    created() {
        if(!this.reportData.id) {
            this.$router.replace('/strong-myreport');
        }
    },
    mounted() {
        // DOM.showPageByClassName('report-page');
        DOM.setDocumentTitle(doctitle.TITLE_STRONG);
    },
    methods: {
        clickBack() {
            this.$router.replace('/strong-myreport');
        },
        clickReport() {
            this.$router.replace('/strong-myreport');
        },
        clickNature() {
            var curPath = this.$router.history.current.path;
                curPath = curPath.replace('strong-report', 'nature/record');
            let detailInfo = this.$store.state.report.detailInfo;
            console.log('clickNature-----', curPath, detailInfo)
            this.$bus.emit('clearDetailNatureTime');
            // this.$store.dispatch('detail/initDetail', detailInfo);
            // this.$router.replace(curPath);
            // setTimeout(() => {
            //     window.scrollTo(0, 0);
            // }, 20);
        },
    }

}
</script>
